window.TUCNavigationManager = SiNavigationManager.extend({
    constructor: function() {
        SiNavigationManager.prototype.constructor.call(this);
        this.progressBackgroundColor = "#DCDCDC";
        this.progressColor = "#8B336F";
        this.progressRadius = 20;
        this.progressStroke = 4;
    },

    start: function() {
        SiNavigationManager.prototype.start.call(this);
        this.listenTo(this.session, "onJunctionUpdate", this.handleOnJunctionUpdate);
    },

    handleOnJunctionUpdate: function(e) {
        if (e.pageData.pageNumber() > 0) {
            this.previousButton.$el.addClass("active");
        } else {
            this.previousButton.$el.removeClass("active");
        }
        this.nextButton.$el.addClass("active");
    },

    setupNavigation: function() {
        SiNavigationManager.prototype.setupNavigation.call(this);
        // this.$navigation.hide();
        // TweenMax.set(this.$navigation, {
        //     y: -1 * this.$navigation.height()
        // });
        this.addLanguageSelection();
    },

    addLanguageSelection: function() {
        $(this.container.dom).addClass("lang-" + this.container.language);
    },

    toggleNavigationBar: function(e) {
        if ((e.pageData.moduleID() == 2) || (e.pageData.moduleID() == 1 && e.pageData.pageID() == "020")) {
			this.showNavigation();
        } else {
            this.hideNavigation();
        }

        if (e.pageData.moduleID() == 2) {
            this.previousButton.$el.addClass("active");

        }
    },

    showNavigation: function() {
		var $progressBars = this.$navigation.find("#progress-nav");
		TweenMax.to($progressBars, 0.5, {
			y: 0,
			opacity: 1,
			ease: Power4.easeOut,
			onStart: function () {
				$progressBars.show();
			},
			onComplete: function () {}
		});

        this.container.$page.addClass("has-nav");
    },

    hideNavigation: function() {
		var $progressBars = this.$navigation.find("#progress-nav");
		
		TweenMax.to($progressBars, 0.5, {
			y: 0 - $progressBars.height(),
			opacity: 0,
			ease: Power4.easeOut,
			onStart: function () {},
			onComplete: function () {
				$progressBars.hide();
			}
		});

        this.container.$page.removeClass("has-nav");
    },

    addButtonListeners: function() {
		// Logger.info("NAVIGATION.addButtonListeners");
        SiNavigationManager.prototype.addButtonListeners.call(this);
        this.$helpButton = this.$navigation.find(".navigation-button.help");
        this.helpButton = new Button({
			el: this.$helpButton,
            buttonClass: " "
        });
		this.listenTo(this.helpButton, "onClick", this.handleHelpButtonClick);

		
        const logoutButton = new Button({
			el: this.$navigation.find("#nav-btn-logout > a"),
			buttonClass: " ",
			isDisabled: !container.componentList.FirebaseStorage.check()
        });

		this.listenTo(logoutButton, "onClick", async () => {
			if( logoutButton.isDisabled() ) {
			    return
			};
			await this.container.componentList.FirebaseStorage.logout();
			window.location.reload();
		});

        const profileButton = new Button({
            el: this.$navigation.find("#nav-btn-profile > a"),
            buttonClass: " ",
            isDisabled: !container.componentList.FirebaseStorage.check()
        });

        this.listenTo(profileButton, "onClick", async () => {
            if( profileButton.isDisabled() ) {
                return
            }
            container.router.navigate('global/profile', {
                trigger: true
            });
        });

		const firebase = this.container.componentList.FirebaseStorage;

		this.listenTo(firebase, "onFirebaseAuthStateChanged", ({user}) => {
            logoutButton.toggleDisabled(!user);
            profileButton.toggleDisabled(!user);
        });
		
		
		this.$resetButton = this.$navigation.find("#nav-btn-reset");

		this.listenTo( this.container.session, "onChangeSlide", function(e) {
			var module = e.pageData.moduleNumber();
			var page = e.pageData.pageNumber();
			// Logger.info("ResetButton", module, e)

			if (module > 0 && page > 0 ) {
				this.$resetButton.show();
			} else {
				this.$resetButton.hide();
			}
		})

    },

    handleHelpButtonClick: function() {
        if (!this.helpButton.isDisabled()) {
            if (this.helpPopup.isOpen) {
                this.helpPopup.hidePopupWindow();
            } else {
                this.helpPopup.showPopupWindow();
            }
        }
    },

    addListeners: function() {
        SiNavigationManager.prototype.addListeners.call(this);

        this.helpPopup = this.container.getComponent("HelpPopup");
        this.listenTo(this.helpPopup, "onContentMatched", this.handleContentMatched);
        this.listenTo(this.helpPopup, "onNoContentMatched", this.handleNoContentMatched);
    },

    handleContentMatched: function() {
        this.helpButton.toggleDisabled(false);

        TweenMax.to(this.$helpButton, 0.3, {
            scale: 1,
            opacity: 1,
            ease: Power4.easeInOut
        });
    },

    handleNoContentMatched: function() {
        this.helpButton.toggleDisabled(true);

        TweenMax.to(this.$helpButton, 0.3, {
            scale: 0.5,
            opacity: 0,
            ease: Power4.easeInOut
        });
    },

    handleNextButtonClick: function(e) {
        if (this.nextButton.$el.hasClass("active")) {
            this.container.router.next();
        }
    },

    handlePreviousButtonClick: function(e) {
        //Temp fix the pageID 010_010 need to change as per requirement
        var pageData = this.container.session.currentPageData;
        if (this.container.isLocked && pageData.pageID() === "010_010") {
            return;
        } else {
            if (this.previousButton.$el.hasClass("active")) {
                this.container.router.previous();
            }
        }
    },

    drawProgress: function() {
        this.circularProgress = new CircularProgress();
        this.circularProgress.draw("total-progress", 70, 100, this.progressRadius, this.progressStroke, this.progressBackgroundColor, this.progressColor, 70, 70);
    },

    setProgress: function(percentage) {
        this.circularProgress.updateProgress(percentage, 100, this.progressRadius);
    },
    getData: function() {
        var data = SiNavigationManager.prototype.getData.call(this);
        data.helpNavigationLabel = LanguageManager.getString("help");
        data.nextLabel = LanguageManager.getString("skip");
        data.guideLabel = LanguageManager.getString("anya");
        data.aboutLabel = LanguageManager.getString("about");
        data.profileLabel = LanguageManager.getString("profile");
        data.resetLabel = LanguageManager.getString("reset");
        data.logoutLabel = LanguageManager.getString("logout");
        return data;
    },

    getContent: function(data) {
        return Handlebars.templates["navigation/tucnavigationmanager"](data);
    },

    handleChangeSlide: function(event) {
        var pageId = event.pageData.pageID();
        var isModule = this.isModule(event.pageData);

        var bookmarkPageID = this.container.getComponent("Storage").getItem("bookmark");
        if (isModule) {
            this.setupModuleNavigation(event, pageId);
        } else if (_.contains(this.globalPages, pageId)) {
            if (pageId != SiNavigationManager.COURSEMAP) {
                this.toggleNavigation(pageId);
                if (bookmarkPageID != "-1") {
                    this.showReturnToPage(true, bookmarkPageID);
                } else {
                    if (event.previousPageData) {
                        if (event.previousPageData.moduleID() == "introduction") {
                            var previousIntroPageId = event.previousPageData.pageID();
                            this.showReturnToPage(true, previousIntroPageId);
                        }
                    } else {
                        this.showReturnToPage(true, "010_010");
                    }
                }
            } else {
                this.circularProgress.updateProgress(0, 100, this.progressRadius);
                this.showReturnToPage(false);
                this.toggleNavigation(pageId);
            }
        } else if (event.pageData.moduleNumber() === null || event.pageData.moduleNumber() == -1) {
            var totalPages = this.container.courseData.getIntroductionModule().getTotalPages();
            var pageNumber = this.session.currentPageData.pageNumber() + 1;
            var percentage = Math.round((pageNumber * 100) / totalPages);
            this.circularProgress.updateProgress(percentage, 100, this.progressRadius);
            this.toggleNavigation(pageId);
            this.showReturnToPage(false);
        }
        this.toggleNavigationBar(event);
	},
	
	showReturnToPage: function (isShow, pageID) {

		var $title = this.$navigation.find(".module-title");
		var $leftBlockCourse = this.$navigation.find("#sub-navigation");
		var $returnToCourse = this.$navigation.find("#return-to-course-navigation");
		var $returnButton = $returnToCourse.find("a");

		if (isShow) {
			$title.text(LanguageManager.getString("return_to_course"));
			TweenMax.to( $returnToCourse, 0.5, {
				y: 0,
				opacity: 1,
				ease: Power4.easeOut,
				onStart: function() {
					$returnToCourse.show();
				},
				onComplete:function() {}
			});

			$returnButton.attr("href", "#page/" + pageID);
			
		} else {
			TweenMax.to($returnToCourse, 0.5, {
				y: 0 - $returnToCourse.height(),
				opacity: 0,
				ease: Power4.easeOut,
				onStart: function () {
					$returnButton.attr("href", '');
				},
				onComplete: function () {
					$returnToCourse.hide();
				}
			});
		}
	},

	showLimitedMenuOptions: function () {
		return;
	},

	showAllMenuOptions: function () {
		return;
	},
});
